export const buttonStyling = {
  justifyContent: { xs: 'left', md: 'center' },
  color: { xs: 'inherit', md: '#BAB1B7' },
  fontSize: 16,
  textTransform: 'none',
  minWidth: 'auto',
  paddingLeft: 2,
  paddingRight: 1,
  display: { xs: 'flex', md: 'inherit' },
}
